import { render, staticRenderFns } from "./courseGoods.vue?vue&type=template&id=99cf4910&scoped=true"
import script from "./courseGoods.vue?vue&type=script&lang=js"
export * from "./courseGoods.vue?vue&type=script&lang=js"
import style0 from "./courseGoods.vue?vue&type=style&index=0&id=99cf4910&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cf4910",
  null
  
)

export default component.exports